<template>

  <b-input-group class="mb-1">
    <b-form-input
      id="datepicker-input"
      v-model="dateText"
      type="text"
      placeholder="DD/MM/YYYY"
      autocomplete="off"
      :state="isValidText ? null : false"
    />
    <b-input-group-append>

      <b-form-datepicker
        v-model="date"
        :hide-header="true"
        :show-decade-nav="true"
        reset-button
        button-only
        selected-variant="primary"
        button-variant="outline-primary"
        size="sm"
        right
        aria-controls="datepicker-input"
        :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }"
      />
    </b-input-group-append>
  </b-input-group>

</template>

<script>
import {
  BFormDatepicker, BFormInput, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import { formatDate, parseDate } from './layouts.utils'

export default {
  name: 'DatePickerInput',
  components: {
    BFormDatepicker, BFormInput, BInputGroupAppend, BInputGroup,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: null,
    },
  },
  data() {
    return {
      isValidText: true,
    }
  },
  computed: {
    date: {
      get() { return this.parse(this.value) },
      set(value) { this.$emit('input', this.parse(value)) },
    },
    dateText: {
      get() { return formatDate(this.value, 'DD/MM/yyyy') },
      set(value) {
        const date = parseDate(value, 'DD/MM/yyyy')
        if (date) this.date = date
        else if (!value) this.date = null
        this.isValidText = !value || date
      },
    },
  },
  methods: {
    parse(val) {
      if (val && typeof val === 'string') {
        return new Date(val)
      }
      return val
    },
  },
}
</script>
